import { Grid, InputLabel, Tooltip, Typography } from "@mui/material";

import { EnhancedTextAreaFieldRHF } from "@websential/cosmic";
import InfoIcon from '@mui/icons-material/Info';
import { RHookFormNumericFormatTextField } from "../../../components/TaxSlipDataInput/RHookFormNumericFormatTextField";
import { RHookFormTextField } from "../../../components/TaxSlipDataInput/RHookFormTextField";
import React from "react";

export interface ITaxSlipDataInput {
  id: string;
  label: string;
  boxNumber: string;
  showAdjustedInput?: boolean;
  alert?: boolean;
  alertTitle?: string;
  defaultValue?: string;
  titlePlacement?: any;
  readOnly?: boolean;
  onChange?: any;
  textfield?: any;
  optionalTextField?: any;
}

export const TaxSlipDataInput: React.FC<ITaxSlipDataInput> = ({
  id,
  label,
  boxNumber,
  alert,
  alertTitle,
  titlePlacement,
  defaultValue,
  readOnly,
  onChange,
  textfield,
  optionalTextField
}) => {
  return (
    <Grid container columnSpacing={2} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
      {optionalTextField || textfield ? <>
        <Grid
          size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}
          sx={{ textAlign: "left", paddingTop: 2 }}
        >
          <InputLabel sx={{ display: "flex" }}>
            <Typography variant="subtitle2">{label}</Typography>
            {alert === true ? (
              <Tooltip title={alertTitle} placement={titlePlacement}>
                <InfoIcon sx={{ fontSize: "1.1rem", margin: "1.5px" }} />
              </Tooltip>
            ) : undefined}
          </InputLabel>
        </Grid>
        <Grid size={{ xs: 7, sm: 7, md: 7, lg: 7, xl: 7 }}>
          <RHookFormTextField id={`${id}`} testId={`${id}-1`} defaultValue={defaultValue}
            readOnly={readOnly}
            onChange={onChange}
            textAlign={'start'} />
        </Grid></>
        :
        <><Grid
          size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}
          sx={{ textAlign: "left", paddingTop: 2 }}
        >
          <InputLabel sx={{ display: "flex" }}>
            <Typography variant="subtitle2">{label}</Typography>
            {alert === true ? (
              <Tooltip title={alertTitle} placement={titlePlacement}>
                <InfoIcon sx={{ fontSize: "1.1rem", margin: "1.5px" }} />
              </Tooltip>
            ) : undefined}
          </InputLabel>
        </Grid>
          <Grid
            size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
            sx={{ textAlign: "right", paddingTop: 2 }}
          >
            <InputLabel>
              <Typography variant="subtitle2">{boxNumber}</Typography>
            </InputLabel>
          </Grid>
          <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
            {/* <RHookFormTextField id={`${id}`} testId={`${id}-1`} defaultValue={defaultValue}
        readOnly={readOnly}
        onChange={onChange}
        textAlign={'end'}/> */}
            {/* {textfield ?  */}
            <RHookFormTextField
              id={`${id}`} testId={`${id}-1`} defaultValue={defaultValue}
              readOnly={readOnly}
              onChange={onChange}
              textAlign={'end'}
            />
            {/* : 
        <RHookFormNumericFormatTextField
        id={`${id}`} testId={`${id}-1`} defaultValue={defaultValue}
        readOnly={readOnly}
        onChange={onChange}
        textAlign={'end'}
        />
        } */}
          </Grid></>}
    </Grid>
  );
};
